var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.87501V1.10871C0.662363 0.310474 1.40964 -0.0461826 2.51358 0.0047684C4.17798 0.157621 4.78617 0.840587 6.16507 1.10871C7.38789 1.34648 8.23708 0.548246 8.78055 0.0047684V1.77107C7.88042 2.63724 7.18409 2.79009 6.16507 2.79009C5.14605 2.79009 3.60054 1.73144 2.41168 1.65218C1.39266 1.58425 0.379302 2.42777 0 2.87501Z",
    fill: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.016983 6.00001V4.23371C0.679346 3.43547 1.42663 3.07882 2.53057 3.12977C4.19496 3.28262 4.80315 3.96559 6.18205 4.23371C7.40488 4.47148 8.25406 3.67325 8.79754 3.12977V4.89607C7.8974 5.76224 7.20107 5.91509 6.18205 5.91509C5.16303 5.91509 3.61752 4.85644 2.42866 4.77718C1.40964 4.70925 0.396285 5.55277 0.016983 6.00001Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundNumber);
export default __webpack_public_path__ + "static/media/round-number.756984b50f19a22542045aa56bffaa34.svg";
export { ForwardRef as ReactComponent };